import { HAS_WINDOW } from './window.js';

/* cspell: disable */
const UA = HAS_WINDOW ? navigator.userAgent : '';
const playwright = HAS_WINDOW ? (navigator.webdriver ?? false) : false;
const mac = /macintosh/i.test(UA);
const iOS = /ipad|iphone|ipod/i.test(UA);
const apple = mac || iOS;
const android = /android/i.test(UA);
const firefox = /firefox|iceweasel|fxios/i.test(UA);
const chrome = !firefox && /chrome|crios|crmo/i.test(UA);
const safari = apple && !firefox && !chrome && /safari|applewebkit/i.test(UA);

export { android, apple, chrome, firefox, iOS, mac, playwright, safari };
//# sourceMappingURL=platform.js.map
